import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgTrappen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M26 14V8h6v24H8v-6h6v-6h6v-6z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M17 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgTrappen);

export default ForwardRef;
